import React from "react";
import { Link } from "react-router-dom";
import { useSiteConfig } from "@/context/SiteConfigContext";

const DEFAULT_LOGO = "https://customer-assets-agu9un31.emergentagent.net/job_service-catalog-pro-5/artifacts/v0gncca3_Unicorp-New-Logo-200x200.png";
const SIZES = { sm: "h-9", md: "h-11", lg: "h-12", xl: "h-14" };

// One consistent, config-driven UNICORP brand mark. The approved logo already
// contains the wordmark, so no separate "UNICORP" text is rendered beside it.
export default function Brand({ size = "md", to = "/", dark = false, className = "" }) {
  const { config } = useSiteConfig();
  const src = (dark && config?.logo_dark_url) ? config.logo_dark_url : (config?.logo_url || DEFAULT_LOGO);
  const img = <img src={src} alt="UNICORP" className={`${SIZES[size] || SIZES.md} w-auto object-contain ${className}`} data-testid="brand-logo" />;
  if (!to) return img;
  return <Link to={to} aria-label="UNICORP home" className="inline-flex items-center shrink-0">{img}</Link>;
}
